module.exports = __webpack_public_path__ + "static/fonts-ae8105bc1a89bfe2969a867a3f04c356.jpg";